import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/family_users/app_bar
export const appBar = async () => {
  const response = await new Request().get('/ajax/family_users/app_bar')
  return Util.Obj.keysToCamel(response.data?.app_bar_config)
}
